module.exports = __webpack_public_path__ + "img/bbva.4574753.svg";